<div class="header">
  <img src="assets/logo_hvdm.png" height="40" />
</div>
<div class="login">
  <form role="form" class="container" [formGroup]="parts" (submit)="doLogin()">
    <div class="error-login" *ngIf="errorLogin">Usuario o contraseña incorrecta</div>
    <div class="form-item">
      <input type="text" formControlName="username" tabindex="0" autofocus="on" required placeholder="Usuario" />
      <div class="error" *ngIf="hasError('username','required') && (isDirty('username') || isTouched('username'))">El usuario es obligatorio</div>
    </div>
    <div class="form-item">
      <input type="password" formControlName="password" tabindex="0" required placeholder="Contraseña" />
      <div class="error" *ngIf="hasError('password','required') && (isDirty('password') || isTouched('password'))">La contraseña es obligatoria</div>
    </div>
    <div class="form-item button">
      <button type="submit" [disabled]="!parts.valid" tabindex="0">Acceder</button>
    </div>
  </form>
</div>